export default "__VITE_ASSET__zrXauhOJ__"